export default __webpack_public_path__ + "src/components/pages/shared/images/fa8cb8d375647a030942033c04fa4d92.png";